import React, { Component } from 'react';
import detectBrowser from 'detect-browser';
import _ from 'underscore';
import BaseModal from '../Modals/BaseModal';

require('./index.scss');

class UnsupportedBrowser extends Component {
    constructor (props) {
        super(props);
    }

    _getBrowserInfo() {
        const { name, version } = detectBrowser;
        return `${name.charAt(0).toUpperCase()}${name.slice(1)} ${version}`;
    }

    render () {
        return (
            <BaseModal
                isOpen={true}
                hasCloseButton={false}
                renderWithHeader={true}
                title="Unsupported Browser"
                shouldCloseOnOverlayClick={false}
            >
                <div className="errorModal container">
                    <h2>Your browser is unsupported: {this._getBrowserInfo()}</h2>
                    <p>Supported browsers:</p>
                    <ul>
                        <li>Chrome (latest version)</li>
                        <li>Firefox (latest version)</li>
                        <li>Edge</li>
                        <li>Internet Explorer 11</li>
                        <li>Safari</li>
                    </ul>
                    <p>
                        Please <a href={`mailto:${process.env.TECH_SUPPORT_EMAIL}`}>
                            contact technical support
                        </a> if you need help.
                    </p>
                </div>
            </BaseModal>
        );
    }
}

export default UnsupportedBrowser;



// WEBPACK FOOTER //
// ./app/components/UnsupportedBrowser/index.jsx